import React, { useEffect, useState } from 'react'
import { COLORES } from '../../../../../config/colores'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  totalizador: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    '@media (min-width: 768px)': {
      flexWrap: 'no-wrap',
      justifyContent: 'flex-end'
    }
  }
}))

function TotalizadorCodigosDeCupo (props) {
  const { codigosDeCupo } = props
  const [totalPorEstado, setTotalPorEstado] = useState([])

  const classes = useStyles()

  useEffect(() => {
    const total = []
    if (codigosDeCupo.length > 0 && totalPorEstado.length === 0) {
      codigosDeCupo.map((c) => {
        const estadoExiste = total.find(t => t.estado === c.estado)
        if (estadoExiste) {
          estadoExiste.cantidad += 1
        } else {
          total.push({ estado: c.estado, cantidad: 1 })
        }
        return total
      })
      setTotalPorEstado(total)
    }
  }, [totalPorEstado, codigosDeCupo, setTotalPorEstado])

  const renderTotales = () => {
    const total = totalPorEstado.map((t) => {
      return (
        <div
          style={{
            borderRadius: '22px',
            backgroundColor: COLORES.grey.dark,
            color: 'white',
            margin: '8px',
            padding: '8px 22px'
          }}
          key={t}
        >
          <h6 style={{ margin: 0 }}>{t.estado} : <b>{t.cantidad}</b></h6>
        </div>
      )
    })
    return total
  }

  return (
    <div className={classes.totalizador}>
      { totalPorEstado.length > 0 && renderTotales() }
    </div>
  )
}

export default TotalizadorCodigosDeCupo
